import { Typography } from 'antd';
import { Link } from 'react-router-dom';

// who's signed in, at the end of the tab bar, so you can tell which account
// you're in before logging out
export const Account = ({ email }: { email?: string }) =>
	<span style={{ padding: '0 16px', whiteSpace: 'nowrap' }}>
		{email && <Typography.Text type="secondary" style={{ marginRight: 12 }}>{email}</Typography.Text>}
		<Link to="/logout">Log out</Link>
	</span>;
